"use strict";
/**
 * This file was auto-generated by Fern from our API Definition.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.RenderType = void 0;
exports.RenderType = {
    Mp4: "mp4",
    Aac: "aac",
    Mp3: "mp3",
    Wav: "wav",
    Aaf: "aaf",
    TracksZip: "tracks_zip",
    ClipsZip: "clips_zip",
};
